import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => createStyles({
    collapse: {
        cursor: "pointer",
    },
}));

export default useStyles;